<bp-hl-area-container name="Adresse">
	<div class="touch-form">
		<div class="form-row">
			<div class="form-label-cell">Forstamt</div>
			<div class="form-input-cell multi equal-width">
				<wd-typeahead [(model)]="data.header.forstamt" name="Forstamt" label="Forstamt" placement="bottom"></wd-typeahead>
				<wd-typeahead [(model)]="data.header.revier" name="Revier" label="Revier" [filter]="forstamtFilter(data.header.forstamt)" placement="bottom"></wd-typeahead>
			</div>
		</div>
		<div class="form-row">
			<div class="form-label-cell">Forstbetrieb</div>
			<div class="form-input-cell multi equal-width">
				<wd-text-input [(model)]="data.header.forstbetrieb" name="Forstbetrieb" label="Forstbetrieb"></wd-text-input>
			</div>
		</div>
		<div class="form-row">
			<div class="form-label-cell">Forstadresse</div>
			<div class="form-input-cell multi equal-width">
				<wd-text-input [(model)]="data.header.adresse.abteilung" name="Abteilung" label="Abteilung"></wd-text-input>
				<wd-list-input [(model)]="data.header.adresse.unterabteilung" name="Unterabteilung" label="Unterabteilung"></wd-list-input>
				<wd-text-input [(model)]="data.header.adresse.teilflaeche" name="Teilfläche" label="Teilfläche"></wd-text-input>
			</div>
		</div>
		<div class="form-row">
			<div class="form-label-cell">Katasteradresse</div>
			<div class="form-input-cell multi equal-width">
				<wd-text-input name="Gemarkung" label="Gemarkung" [(model)]="data.header.adresse.gemarkung"></wd-text-input>
				<wd-number-input name="Flur" label="Flur" class="text-left" [(model)]="data.header.adresse.flur"></wd-number-input>
				<wd-text-input name="Flurstück" label="Flurst." [(model)]="data.header.adresse.flurstueck"></wd-text-input>
			</div>
		</div>
		<div class="form-section-header">Koordinaten</div>
		<div class="form-row">
			<div class="form-label-cell">Koordinaten</div>
			<div class="form-input-cell multi equal-width">
				<wd-list-input [(model)]="data.header.koordinaten.system" name="Koordinatensystem" label="System" tableName="Koordinatensysteme" nonEmpty></wd-list-input>
				<wd-number-input [(model)]="data.header.koordinaten.x" name="X-Koordinate" label="X" class="label-right" nonEmpty></wd-number-input>
				<wd-number-input [(model)]="data.header.koordinaten.y" name="Y-Koordinate" label="Y" class="label-right" nonEmpty></wd-number-input>
			</div>
		</div>
	</div>
</bp-hl-area-container>
